export const mergeDeep = (obj, ...sources) => {
  if (!sources.length) return obj;
  const target = obj;
  const source = sources.shift();

  if (source && typeof source === 'object' && !Array.isArray(source)) {
    Object.keys(source).forEach(key => {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        if (!target[key]) {
          target[key] = {};
        }

        mergeDeep(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  }

  return mergeDeep(target, ...sources);
};
export const generateKeyByObject = (obj, separator = '-', join = '/') => Object.keys(obj).map(key => `${key}${separator}${obj[key]}`).join(join);